<template>
  <section>
    <div class="header">
      <v-button
        gray
        @click="handleCreateLink">Create New Link</v-button>
    </div>

    <div class="main">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick">
        <el-table-column
          width="120"
          label="Created">
          <template #default="{row}">
            <div class="flex-column">
              <span>{{ row.created_at.split(" ")[0] }}</span>
              <span> {{ row.created_at.split(" ")[1] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="Logo">
          <template #default="{row}">
            <div class="logo">
              <img :src="row.file_url">
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="130"
          prop="partner_nm"
          label="Partner Name">
        </el-table-column>
        <el-table-column
          min-width="120"
          prop="coupon_code"
          label="Coupon">
        </el-table-column>
        <el-table-column
          min-width="120"
          prop="class_language"
          label="Product">
        </el-table-column>
        <el-table-column
          width="120"
          label="Period">
          <template #default="{row}">
            <div class="flex-column">
              <span>{{ row.period.split("to")[0] }} to</span>
              <span> {{ row.period.split("to")[1] }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          label="Status">
          <template #default="{row}">
            <span
              class="status"
              :class="{
                'green': row.status == 1,
                'gray': row.status == 2,
              }">
              {{row.status_language}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="150"
          label="Link">
          <template #default="{row}">
            <a
              class="link"
              :href="row.link"
              @click="toLink($event, row.link)">
              <span>{{row.link}}</span>
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />

    <!-- dialog -->
    <partner-link-dialog
      ref="partner-link-dialog"
      :isEdit="isEdit"
      :rowData="rowData"
      @success="handleSuccess"></partner-link-dialog>
  </section>
</template>

<script>
import PartnerLinkDialog from './dialog/partner-link-dialog.vue'
import {getCampaginLinkList} from '@/api/micropolicy'

export default {
  name: 'PartnerLinks',
  components:{
    PartnerLinkDialog
  },
  data () {
    return {
      tableData: [],
      pageConfig: {
        currentPage: 1,
        total: 10
      },
      rowData:{
        partner_nm: '',
        class_id: '',
        cmnt_dt: '',
        expry_dt: '',
        coupon_code: '',
        id: '',
        file_url: '',
        code_save: 0
      },
      isEdit: false
    }
  },
  created(){
    this.network().getCampaginLinkList()
  },
  methods: {
    handleCreateLink(){
      this.isEdit = false
      this.$refs['partner-link-dialog'].changeDialog()
      this.$refs['partner-link-dialog'].resetForm()
    },

    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getCampaginLinkList()
    },

    rowClick(row) {
      this.rowData = {
        partner_nm: '',
        class_id: '',
        cmnt_dt: '',
        expry_dt: '',
        coupon_code: '',
        id: '',
        file_url: '',
        code_save: 0
      }
      Object.keys(this.rowData).forEach(key => {
        this.$set(this.rowData, key, row[key])
      })
      this.isEdit = true
      this.$refs['partner-link-dialog'].changeDialog()
    },

    toLink(e, link){
      e.stopPropagation()
      e.preventDefault()
      if(link){
        window.open(link, '_blank')
      }
    },

    handleSuccess(){
      this.network().getCampaginLinkList()
    },

    network(){
      return {
        getCampaginLinkList: async () => {
          const {data} = await getCampaginLinkList()
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
.header{
  text-align: right;
}

.main{
  margin-top: 20px;
  .logo{
    img{
      width: 100%;
      height: 100%;
    }
  }
  .status{
    padding: 1px 8px;
    border-radius: 100px;
    color: #FFFFFF;
    font-weight: 600;
    height: 18px;
    font-size: 12px;
    line-height: 18px;
    &.green{
      background: #28A745;
    }
    &.gray{
      background: #6A737D;
    }
  }
  .link{
    color: #0366D6;
    text-decoration: none;
    cursor: pointer;
  }
}

::v-deep .el-table{
  border-radius: 4px;
  border: 1px solid #E1E4E8;
  tr{
    td{
      padding: 10px 15px 10px 0!important;
      vertical-align: top;
      margin-right: 15px;
     .cell{
       line-height: 23px;
       position: relative;
       height: inherit;
       padding: 0;
     }
     &:first-child{
      padding-left: 15px !important;
     }
    }
  }
}
::v-deep .tableHeader {
  margin-top: 30px;
  background: #F6F8FA !important;
  border-bottom: 1px solid #E1E4E8;

  th {
    background-color: #F6F8FA !important;
    font-family: Inter;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    letter-spacing: -0.15px;
    padding: 10px 0!important;
    color: #24292E!important;
    .cell{
      padding-left: 0;
    }
    &:first-child{
      padding-left: 15px !important;
     }
  }
}
</style>
